export type REPORTS_HAS_ERRORED = typeof REPORTS_HAS_ERRORED
export const REPORTS_HAS_ERRORED = '[Reports] REPORTS_HAS_ERRORED'

export const GET_REPORTS = '[Reports] GET_REPORTS'
export type GET_REPORTS = typeof GET_REPORTS

export const GET_REPORTS_SUCCESS = '[Reports] GET_REPORTS_SUCCESS'
export type GET_REPORTS_SUCCESS = typeof GET_REPORTS_SUCCESS

export const SET_REPORTS_FILTER = '[Reports] SET_REPORTS_FILTER'
export type SET_REPORTS_FILTER = typeof SET_REPORTS_FILTER

export const GET_TASKS_BY_PROJECT_FILTER = '[Reports] GET_TASKS_BY_PROJECT_FILTER'
export type GET_TASKS_BY_PROJECT_FILTER = typeof GET_TASKS_BY_PROJECT_FILTER

export const GET_TASKS_BY_PROJECT_FILTER_SUCCESS = '[Reports] GET_TASKS_BY_PROJECT_FILTER_SUCCESS'
export type GET_TASKS_BY_PROJECT_FILTER_SUCCESS = typeof GET_TASKS_BY_PROJECT_FILTER_SUCCESS

export const GET_TASKS_BY_PROJECT = '[Reports] GET_TASKS_BY_PROJECT'
export type GET_TASKS_BY_PROJECT = typeof GET_TASKS_BY_PROJECT

export const GET_PAGINATED_TASKS_BY_PROJECT_SUCCESS = '[Reports] GET_PAGINATED_TASKS_BY_PROJECT_SUCCESS'
export type GET_PAGINATED_TASKS_BY_PROJECT_SUCCESS = typeof GET_PAGINATED_TASKS_BY_PROJECT_SUCCESS

export const SET_PAGINATION_PAGE_TASKS_BY_PROJECT = '[Reports] SET_PAGINATION_PAGE_TASKS_BY_PROJECT'
export type SET_PAGINATION_PAGE_TASKS_BY_PROJECT = typeof SET_PAGINATION_PAGE_TASKS_BY_PROJECT

export const SET_LOADER = '[Reports] SET_LOADER'
export type SET_LOADER = typeof SET_LOADER

export const SET_DATA_LOADER = '[Reports] SET_DATA_LOADER'
export type SET_DATA_LOADER = typeof SET_DATA_LOADER

export const SET_CHART_LOADER = '[Reports] SET_CHART_LOADER'
export type SET_CHART_LOADER = typeof SET_CHART_LOADER

export const SET_TASKS_BY_PROJECT_SORT = '[Reports] SET_TASKS_BY_PROJECT_SORT'
export type SET_TASKS_BY_PROJECT_SORT = typeof SET_TASKS_BY_PROJECT_SORT

export const GET_PROJECT_LIST_FILTER = '[Reports] GET_PROJECT_LIST_FILTER'
export type GET_PROJECT_LIST_FILTER = typeof GET_PROJECT_LIST_FILTER

export const GET_PROJECT_LIST_FILTER_SUCCESS = '[Reports] GET_PROJECT_LIST_FILTER_SUCCESS'
export type GET_PROJECT_LIST_FILTER_SUCCESS = typeof GET_PROJECT_LIST_FILTER_SUCCESS

export const GET_PROJECT_LIST = '[Reports] GET_PROJECT_LIST'
export type GET_PROJECT_LIST = typeof GET_PROJECT_LIST

export const GET_PROJECT_LIST_SUCCESS = '[Reports] GET_PROJECT_LIST_SUCCESS'
export type GET_PROJECT_LIST_SUCCESS = typeof GET_PROJECT_LIST_SUCCESS

export const SET_PAGINATION_PAGE_PROJECT_LIST = '[Reports] SET_PAGINATION_PAGE_PROJECT_LIST'
export type SET_PAGINATION_PAGE_PROJECT_LIST = typeof SET_PAGINATION_PAGE_PROJECT_LIST

export const SET_PROJECT_LIST_SORT = '[Reports] SET_PROJECT_LIST_SORT'
export type SET_PROJECT_LIST_SORT = typeof SET_PROJECT_LIST_SORT

export const GET_FTE_BY_PROJECT_FILTER = '[Reports] GET_FTE_BY_PROJECT_FILTER'
export type GET_FTE_BY_PROJECT_FILTER = typeof GET_FTE_BY_PROJECT_FILTER

export const GET_FTE_BY_PROJECT_FILTER_SUCCESS = '[Reports] GET_FTE_BY_PROJECT_FILTER_SUCCESS'
export type GET_FTE_BY_PROJECT_FILTER_SUCCESS = typeof GET_FTE_BY_PROJECT_FILTER_SUCCESS

export const GET_FTE_BY_PROJECT = '[Reports] GET_FTE_BY_PROJECT'
export type GET_FTE_BY_PROJECT = typeof GET_FTE_BY_PROJECT

export const GET_FTE_BY_PROJECT_SUCCESS = '[Reports] GET_FTE_BY_PROJECT_SUCCESS'
export type GET_FTE_BY_PROJECT_SUCCESS = typeof GET_FTE_BY_PROJECT_SUCCESS

export const SET_PAGINATION_PAGE_FTE_BY_PROJECT = '[Reports] SET_PAGINATION_PAGE_FTE_BY_PROJECT'
export type SET_PAGINATION_PAGE_FTE_BY_PROJECT = typeof SET_PAGINATION_PAGE_FTE_BY_PROJECT

export const SET_FTE_BY_PROJECT_SORT = '[Reports] SET_FTE_BY_PROJECT_SORT'
export type SET_FTE_BY_PROJECT_SORT = typeof SET_FTE_BY_PROJECT_SORT

export const GET_EXPENDITURE_PHASING = '[Reports] GET_EXPENDITURE_PHASING'
export type GET_EXPENDITURE_PHASING = typeof GET_EXPENDITURE_PHASING

export const GET_EXPENDITURE_PHASING_SUCCESS = '[Reports] GET_EXPENDITURE_PHASING_SUCCESS'
export type GET_EXPENDITURE_PHASING_SUCCESS = typeof GET_EXPENDITURE_PHASING_SUCCESS

export const SET_PAGINATION_PAGE_EXPENDITURE_PHASING = '[Reports] SET_PAGINATION_PAGE_EXPENDITURE_PHASING'
export type SET_PAGINATION_PAGE_EXPENDITURE_PHASING = typeof SET_PAGINATION_PAGE_EXPENDITURE_PHASING

export const SET_EXPENDITURE_PHASING_SORT = '[Reports] SET_EXPENDITURE_PHASING_SORT'
export type SET_EXPENDITURE_PHASING_SORT = typeof SET_EXPENDITURE_PHASING_SORT

export const SET_EXPENDITURE_PHASING_CHART_TYPE = '[Reports] SET_EXPENDITURE_PHASING_CHART_TYPE'
export type SET_EXPENDITURE_PHASING_CHART_TYPE = typeof SET_EXPENDITURE_PHASING_CHART_TYPE

export const GET_EXPENDITURE_PHASING_CHART = '[Reports] GET_EXPENDITURE_PHASING_CHART'
export type GET_EXPENDITURE_PHASING_CHART = typeof GET_EXPENDITURE_PHASING_CHART

export const GET_EXPENDITURE_PHASING_CHART_SUCCESS = '[Reports] GET_EXPENDITURE_PHASING_CHART_SUCCESS'
export type GET_EXPENDITURE_PHASING_CHART_SUCCESS = typeof GET_EXPENDITURE_PHASING_CHART_SUCCESS

export const GET_DEPARTMENT_UTILIZATION_FILTER = '[Reports] GET_DEPARTMENT_UTILIZATION_FILTER'
export type GET_DEPARTMENT_UTILIZATION_FILTER = typeof GET_DEPARTMENT_UTILIZATION_FILTER

export const GET_DEPARTMENT_UTILIZATION_FILTER_SUCCESS = '[Reports] GET_DEPARTMENT_UTILIZATION_FILTER_SUCCESS'
export type GET_DEPARTMENT_UTILIZATION_FILTER_SUCCESS = typeof GET_DEPARTMENT_UTILIZATION_FILTER_SUCCESS

export const GET_DEPARTMENT_UTILIZATION = '[Reports] GET_DEPARTMENT_UTILIZATION'
export type GET_DEPARTMENT_UTILIZATION = typeof GET_DEPARTMENT_UTILIZATION

export const GET_DEPARTMENT_UTILIZATION_SUCCESS = '[Reports] GET_DEPARTMENT_UTILIZATION_SUCCESS'
export type GET_DEPARTMENT_UTILIZATION_SUCCESS = typeof GET_DEPARTMENT_UTILIZATION_SUCCESS

export const SET_PAGINATION_PAGE_DEPARTMENT_UTILIZATION = '[Reports] SET_PAGINATION_PAGE_DEPARTMENT_UTILIZATION'
export type SET_PAGINATION_PAGE_DEPARTMENT_UTILIZATION = typeof SET_PAGINATION_PAGE_DEPARTMENT_UTILIZATION

export const SET_DEPARTMENT_UTILIZATION_SORT = '[Reports] SET_DEPARTMENT_UTILIZATION_SORT'
export type SET_DEPARTMENT_UTILIZATION_SORT = typeof SET_DEPARTMENT_UTILIZATION_SORT

export const SET_DEPARTMENT_UTILIZATION_CHART_TYPE = '[Reports] SET_DEPARTMENT_UTILIZATION_CHART_TYPE'
export type SET_DEPARTMENT_UTILIZATION_CHART_TYPE = typeof SET_DEPARTMENT_UTILIZATION_CHART_TYPE

export const GET_DEPARTMENT_UTILIZATION_CHART = '[Reports] GET_DEPARTMENT_UTILIZATION_CHART'
export type GET_DEPARTMENT_UTILIZATION_CHART = typeof GET_DEPARTMENT_UTILIZATION_CHART

export const GET_DEPARTMENT_UTILIZATION_CHART_SUCCESS = '[Reports] GET_DEPARTMENT_UTILIZATION_CHART_SUCCESS'
export type GET_DEPARTMENT_UTILIZATION_CHART_SUCCESS = typeof GET_DEPARTMENT_UTILIZATION_CHART_SUCCESS

export const GET_PROJECT_HOURS_PHASING_FILTER = '[Reports] GET_PROJECT_HOURS_PHASING_FILTER'
export type GET_PROJECT_HOURS_PHASING_FILTER = typeof GET_PROJECT_HOURS_PHASING_FILTER

export const GET_PROJECT_HOURS_PHASING_FILTER_SUCCESS = '[Reports] GET_PROJECT_HOURS_PHASING_FILTER_SUCCESS'
export type GET_PROJECT_HOURS_PHASING_FILTER_SUCCESS = typeof GET_PROJECT_HOURS_PHASING_FILTER_SUCCESS

export const GET_PROJECT_HOURS_PHASING = '[Reports] GET_PROJECT_HOURS_PHASING'
export type GET_PROJECT_HOURS_PHASING = typeof GET_PROJECT_HOURS_PHASING

export const GET_PROJECT_HOURS_PHASING_SUCCESS = '[Reports] GET_PROJECT_HOURS_PHASING_SUCCESS'
export type GET_PROJECT_HOURS_PHASING_SUCCESS = typeof GET_PROJECT_HOURS_PHASING_SUCCESS

export const SET_PAGINATION_PAGE_PROJECT_HOURS_PHASING = '[Reports] SET_PAGINATION_PAGE_PROJECT_HOURS_PHASING'
export type SET_PAGINATION_PAGE_PROJECT_HOURS_PHASING = typeof SET_PAGINATION_PAGE_PROJECT_HOURS_PHASING

export const SET_PROJECT_HOURS_PHASING_SORT = '[Reports] SET_PROJECT_HOURS_PHASING_SORT'
export type SET_PROJECT_HOURS_PHASING_SORT = typeof SET_PROJECT_HOURS_PHASING_SORT

export const SET_PROJECT_HOURS_PHASING_CHART_TYPE = '[Reports] SET_PROJECT_HOURS_PHASING_CHART_TYPE'
export type SET_PROJECT_HOURS_PHASING_CHART_TYPE = typeof SET_PROJECT_HOURS_PHASING_CHART_TYPE

export const GET_PROJECT_HOURS_PHASING_CHART = '[Reports] GET_PROJECT_HOURS_PHASING_CHART'
export type GET_PROJECT_HOURS_PHASING_CHART = typeof GET_PROJECT_HOURS_PHASING_CHART

export const GET_PROJECT_HOURS_PHASING_CHART_SUCCESS = '[Reports] GET_PROJECT_HOURS_PHASING_CHART_SUCCESS'
export type GET_PROJECT_HOURS_PHASING_CHART_SUCCESS = typeof GET_PROJECT_HOURS_PHASING_CHART_SUCCESS

export const GET_EXPECTED_PAYMENTS_FILTER = '[Reports] GET_EXPECTED_PAYMENTS_FILTER'
export type GET_EXPECTED_PAYMENTS_FILTER = typeof GET_EXPECTED_PAYMENTS_FILTER

export const GET_EXPECTED_PAYMENTS_FILTER_SUCCESS = '[Reports] GET_EXPECTED_PAYMENTS_FILTER_SUCCESS'
export type GET_EXPECTED_PAYMENTS_FILTER_SUCCESS = typeof GET_EXPECTED_PAYMENTS_FILTER_SUCCESS

export const GET_EXPECTED_PAYMENTS = '[Reports] GET_EXPECTED_PAYMENTS'
export type GET_EXPECTED_PAYMENTS = typeof GET_EXPECTED_PAYMENTS

export const GET_EXPECTED_PAYMENTS_SUCCESS = '[Reports] GET_EXPECTED_PAYMENTS_SUCCESS'
export type GET_EXPECTED_PAYMENTS_SUCCESS = typeof GET_EXPECTED_PAYMENTS_SUCCESS

export const GET_EXPECTED_PAYMENTS_CHART = '[Reports] GET_EXPECTED_PAYMENTS_CHART'
export type GET_EXPECTED_PAYMENTS_CHART = typeof GET_EXPECTED_PAYMENTS_CHART

export const GET_EXPECTED_PAYMENTS_CHART_SUCCESS = '[Reports] GET_EXPECTED_PAYMENTS_CHART_SUCCESS'
export type GET_EXPECTED_PAYMENTS_CHART_SUCCESS = typeof GET_EXPECTED_PAYMENTS_CHART_SUCCESS

export const SET_PAGINATION_PAGE_EXPECTED_PAYMENTS = '[Reports] SET_PAGINATION_PAGE_EXPECTED_PAYMENTS'
export type SET_PAGINATION_PAGE_EXPECTED_PAYMENTS = typeof SET_PAGINATION_PAGE_EXPECTED_PAYMENTS

export const SET_EXPECTED_PAYMENTS_SORT = '[Reports] SET_EXPECTED_PAYMENTS_SORT'
export type SET_EXPECTED_PAYMENTS_SORT = typeof SET_EXPECTED_PAYMENTS_SORT

export const SET_EXPECTED_PAYMENTS_CHART_TYPE = '[Reports] SET_EXPECTED_PAYMENTS_CHART_TYPE'
export type SET_EXPECTED_PAYMENTS_CHART_TYPE = typeof SET_EXPECTED_PAYMENTS_CHART_TYPE

export const GET_EXPECTED_RECEIPTS_FILTER = '[Reports] GET_EXPECTED_RECEIPTS_FILTER'
export type GET_EXPECTED_RECEIPTS_FILTER = typeof GET_EXPECTED_RECEIPTS_FILTER

export const GET_EXPECTED_RECEIPTS_FILTER_SUCCESS = '[Reports] GET_EXPECTED_RECEIPTS_FILTER_SUCCESS'
export type GET_EXPECTED_RECEIPTS_FILTER_SUCCESS = typeof GET_EXPECTED_RECEIPTS_FILTER_SUCCESS

export const GET_EXPECTED_RECEIPTS = '[Reports] GET_EXPECTED_RECEIPTS'
export type GET_EXPECTED_RECEIPTS = typeof GET_EXPECTED_RECEIPTS

export const GET_EXPECTED_RECEIPTS_SUCCESS = '[Reports] GET_EXPECTED_RECEIPTS_SUCCESS'
export type GET_EXPECTED_RECEIPTS_SUCCESS = typeof GET_EXPECTED_RECEIPTS_SUCCESS

export const GET_EXPECTED_RECEIPTS_CHART = '[Reports] GET_EXPECTED_RECEIPTS_CHART'
export type GET_EXPECTED_RECEIPTS_CHART = typeof GET_EXPECTED_RECEIPTS_CHART

export const GET_EXPECTED_RECEIPTS_CHART_SUCCESS = '[Reports] GET_EXPECTED_RECEIPTS_CHART_SUCCESS'
export type GET_EXPECTED_RECEIPTS_CHART_SUCCESS = typeof GET_EXPECTED_RECEIPTS_CHART_SUCCESS

export const SET_PAGINATION_PAGE_EXPECTED_RECEIPTS = '[Reports] SET_PAGINATION_PAGE_EXPECTED_RECEIPTS'
export type SET_PAGINATION_PAGE_EXPECTED_RECEIPTS = typeof SET_PAGINATION_PAGE_EXPECTED_RECEIPTS

export const SET_EXPECTED_RECEIPTS_SORT = '[Reports] SET_EXPECTED_RECEIPTS_SORT'
export type SET_EXPECTED_RECEIPTS_SORT = typeof SET_EXPECTED_RECEIPTS_SORT

export const SET_EXPECTED_RECEIPTS_CHART_TYPE = '[Reports] SET_EXPECTED_RECEIPTS_CHART_TYPE'
export type SET_EXPECTED_RECEIPTS_CHART_TYPE = typeof SET_EXPECTED_RECEIPTS_CHART_TYPE

export const SET_FILTER_PARAMS = '[Reports] SET_FILTER_PARAMS'
export type SET_FILTER_PARAMS = typeof SET_FILTER_PARAMS

export const CLEAR_REPORTS_STATE = '[Reports] CLEAR_REPORTS_STATE'
export type CLEAR_REPORTS_STATE = typeof CLEAR_REPORTS_STATE
